import jsPDF from "jspdf";

// 🧠 Same helper as your working receipt print
const loadImageAsBase64 = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = url;
    img.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = this.width;
      canvas.height = this.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(this, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = reject;
  });
};

export const printCashStatement = async (quantities) => {
  const denominations = [5000, 1000, 500, 100, 50, 20];
  const entryHeight = 6;
  const totalHeight = 140 + (denominations.length * entryHeight);

  const doc = new jsPDF({
    unit: "mm",
    format: [80, totalHeight]
  });

  let y = 8;

  // ✅ Load logo just like receipt function
  const logoBase64 = await loadImageAsBase64(require("../assets/logo.png"));
  doc.addImage(logoBase64, "PNG", 25, y, 30, 30);
  y += 35;

  // HEADER - Business Info
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text("RCS TOPUP & BILLING ENTITY", 40, y, { align: "center" }); y += 5;
  doc.setFont(undefined, 'normal');
  doc.text("22 BELLE PLAINE WAKENAAM", 40, y, { align: "center" }); y += 5;
  doc.text("(592) 662-7987; rcs@rcsgy.net", 40, y, { align: "center" }); y += 6;

  doc.setFontSize(8);
  const services = [
    "MMG+ / Digicel / Enet / GTT Distributor",
    "Massy Agent • Bill Payments • Printery",
    "Insurance & Top-up Services"
  ];
  services.forEach(line => {
    doc.text(line, 40, y, { align: "center" });
    y += 4;
  });

  y += 2;
  doc.line(5, y, 75, y); y += 4;
  doc.setFont(undefined, 'bold');
  doc.text("Cash for Cash Statement", 40, y, { align: "center" }); y += 6;

  doc.setFontSize(8);
  const now = new Date().toLocaleString();
  doc.setFont(undefined, 'normal');
  doc.text(`Date: ${now}`, 5, y); y += 6;

  // Table Headers
  doc.setFont(undefined, 'bold');
  doc.text("Denomination", 5, y);
  doc.text("Qty", 40, y, { align: "center" });
  doc.text("Amount", 75, y, { align: "right" });
  y += 5;

  // Table Body
  doc.setFont(undefined, 'normal');
  let total = 0;

  denominations.forEach((denom) => {
    const qty = quantities[denom] || 0;
    const amount = denom * qty;
    total += amount;

    doc.text(`$${denom}`, 5, y);
    doc.text(`${qty}`, 40, y, { align: "center" });
    doc.text(`$${amount.toLocaleString()}`, 75, y, { align: "right" });
    y += entryHeight;
  });

  // Total Line
  doc.line(5, y, 75, y); y += 6;
  doc.setFont(undefined, 'bold');
  doc.text("Total:", 5, y);
  doc.text(`$${total.toLocaleString()}`, 75, y, { align: "right" }); y += 10;

  // Footer
  doc.setFont(undefined, 'normal');
  doc.setFontSize(9);
  doc.text("--------------------------------------------------------------", 40, y, { align: "center" }); y += 5;
  doc.text("This is not a receipt. Internal use only.", 40, y, { align: "center" });

  doc.internal.pageSize.height = y + 20;

  doc.autoPrint();
  window.open(doc.output("bloburl"), "_blank");
};
